import { render, staticRenderFns } from "./cutImage.vue?vue&type=template&id=2c77b9d4&scoped=true"
import script from "./cutImage.vue?vue&type=script&lang=js"
export * from "./cutImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77b9d4",
  null
  
)

export default component.exports